import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import Select from 'react-select'
import {Modal} from 'react-bootstrap'
import closeIcon from '../../../_metronic/images/closeSymbol.svg'
import {
  GET_SALESCHANNEL_PRODUCTS,
  GET_PRODUCT_FOR_AGENT,
  UPDATE_AGENT,
  GET_AGENT_LEADER_INFO_FOR_EDIT_AGENT,
} from '../../../utils/GraphQLAPI'
import {useLazyQuery, useMutation} from '@apollo/client'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {alert} from '../../../utils/helper'
import {GLOBAL_CONSTANTS} from '../../../utils/GlobalConstants'
import Dropdown from '../../sharedComponent/Dropdown/Dropdown'

const MySwal = withReactContent(Swal)
const fetchPolicy = 'network-only'
const enrollSchema = Yup.object().shape({
  agentFirstName: Yup.string()
    .required('Agent First Name is required')
    .matches(/^[0-9a-zA-Z \b]+$/, 'Special characters are not allowed')
    .matches(/^[^-\s][a-zA-Z0-9_\s-]+$/, 'Space not allowed')
    .min(3, "Agent First Name shouldn't be less than 3 characters")
    .max(40, "Agent First Name shouldn't exceed 40 characters"),
  agentLastName: Yup.string()
    .required('Agent Last Name is required')
    .matches(/^[0-9a-zA-Z \b]+$/, 'Special characters are not allowed')
    .matches(/^[^-\s][a-zA-Z0-9_\s-]+$/, 'Space not allowed')
    .min(3, "Agent Last Name shouldn't be less than 3 characters")
    .max(40, "Agent Last Name shouldn't exceed 40 characters"),
  agentEmail: Yup.string()
    .required('Email ID is required')
    .email('Email ID is not Valid')
    .matches(/^(?!.*@[^,]*,)/, 'Email ID is not Valid')
    .min(10, "Email ID shouldn't less be than 10 characters")
    .max(40, "Email ID shouldn't exceed 40 characters"),
})

export default function EditAgent({
  modalConfig,
  setShowEditModal,
  getSalesChannelAgents,
  agentLeaderList,
}: any) {
  const [options, setOptions] = useState<any>([])
  const [defaultValue, setDefaultValue] = useState<any>([])
  const [removedId, setRemovedId] = useState<any>([])

  const [getAgentLeaderCode] = useLazyQuery(GET_AGENT_LEADER_INFO_FOR_EDIT_AGENT, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    onCompleted: (data) =>
      formik.setFieldValue(
        'agentLeaderName',
        agentLeaderList.filter(
          (leader: any) => leader.leaderCode === data.getAgentLeaderInfoForAgent.leaderCode
        )[0].leaderName
      ),
  })
  const [getSaleschannelProducts] = useLazyQuery(GET_SALESCHANNEL_PRODUCTS, {
    fetchPolicy,
    onCompleted: (data) => {
      setOptions(
        data.getSalesChannelProducts.map((product: any) => ({
          value: product.id,
          label: product.name,
        }))
      )
    },
  })
  const [getProductsForAgents, {data: agentsProductsFromAPI}] = useLazyQuery(
    GET_PRODUCT_FOR_AGENT,
    {
      fetchPolicy,
      variables: {agentId: modalConfig.id},
      onCompleted: (data) => {
        setDefaultValue(
          data.getProductsForAgents.map((product: any) => ({
            value: product.prod_id,
            label: product.prod_name,
          }))
        )
      },
    }
  )
  const [updateAgent] = useMutation(UPDATE_AGENT, {
    fetchPolicy,
    onCompleted: (data) => {
      alert('Agent updated successfully', 'success')
      getSalesChannelAgents()
      handleClose()
    },
    onError: (e) => alert(e.message, 'error'),
  })
  useEffect(() => {
    if (modalConfig.show) {
      ;(async () => {
        await getSaleschannelProducts()
        await getProductsForAgents()
        await formik.setValues({
          agentFirstName: modalConfig.agentFirstName,
          agentLastName: modalConfig.agentLastName,
          agentEmail: modalConfig.agentEmail,
          agentRepId: modalConfig.agentRepId,
          agentLeaderName: '',
        })
        getAgentLeaderCode({
          variables: {
            memberId: modalConfig.id,
          },
        })
      })()
    }
  }, [modalConfig])
  const formik = useFormik({
    initialValues: {
      agentFirstName: '',
      agentLastName: '',
      agentEmail: '',
      agentLeaderName: '',
      agentRepId: '',
    },
    validationSchema: enrollSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      //addedproducts okay
      updateAgent({
        variables: {
          updateAgentInputs: {
            addProductIds: defaultValue
              .map((product: any) => product.value)
              .filter(
                (resultedProdId: any) =>
                  !agentsProductsFromAPI.getProductsForAgents
                    .map((product: any) => product.prod_id)
                    .includes(resultedProdId)
              ),
            removingIds: removedId,
            memberId: modalConfig.id,
            agentFirstName: values.agentFirstName,
            agentLastName: values.agentLastName,
            agentRepId: values.agentRepId,
            leaderCode: Boolean(values.agentLeaderName)
              ? agentLeaderList.filter(
                  (leader: any) => leader.leaderName === values.agentLeaderName
                )[0].leaderCode
              : null,
            // agentName: {
            //   firstName: firstName !== "" ? firstName : null,
            //   lastName: lastName !== "" ? lastName : null
            // }
          },
        },
      })
    },
  })
  const handleClose = () => {
    setShowEditModal({
      show: false,
      id: '',
      agentFirstName: '',
      agentLastName: '',
      agentEmail: '',
      agentStatus: '',
      agentRepId: '',
    })
    setOptions([])
    setDefaultValue([])
    setRemovedId([])
  }
  const handleChange = (value: any) => {
    //check for removed or add
    if (value.length < defaultValue.length) {
      const removeId = defaultValue.filter(
        (product: any) => !value.map((prod: any) => prod.value).includes(product.value)
      )[0].value
      //if removed, check the id of removed data is in API data, if yes add that Id in removed id array of api input
      if (
        agentsProductsFromAPI.getProductsForAgents
          .map((prod: any) => prod.prod_id)
          .includes(removeId)
      ) {
        setRemovedId((prev: any) => [...prev, removeId])
      }
    } else {
      const addedId = value.filter(
        (product: any) => !defaultValue.map((prod: any) => prod.value).includes(product.value)
      )[0].value
      //if user deletes and add the ID which is existing in apiData we dont have to send it in removedId array of update API call
      if (
        agentsProductsFromAPI.getProductsForAgents
          .map((prod: any) => prod.prod_id)
          .includes(addedId)
      ) {
        //added product exisiting in removed ID
        setRemovedId(removedId.filter((id: any) => id !== addedId))
      }
    }
    setDefaultValue(value)
  }

  return (
    <Modal
      id='kt-modal_Edit_app'
      tabIndex={-1}
      aria-hidden='true'
      show={modalConfig.show}
      dialogClassName='modal-dialog modal-dialog modal-dialog-centered mw-650px'
      onHide={() => handleClose()}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title text-gray-800 fs-3 fw-bolder'>
            {modalConfig.agentFirstName} {modalConfig.agentLastName}
          </h5>
          <div className='d-flex align-items-center'>
            <div className='d-flex  align-items-center'>
              <h6 className='text-gray-600 fs-6 fw-semibold'>Status : </h6>
              <h6>
                <span
                  style={{textTransform: 'capitalize'}}
                  className={`badge ${
                    modalConfig.agentStatus === 'pending'
                      ? 'badge-light-warning'
                      : 'badge-light-success'
                  } p-2 ms-2`}
                >
                  {modalConfig.agentStatus}
                </span>
              </h6>
            </div>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={(e) => handleClose()}
            >
              <img className='svg-icon-1' src={closeIcon} alt='close' />
            </div>
          </div>
        </div>
        <div className='modal-body'>
          <div className='mb-9'>
            <label className='form-label'>
              Agent First Name <span className='h5 text-danger'>*</span>
            </label>
            <input
              type='text'
              className='form-control form-control-solid'
              placeholder='Enter Agent Name'
              {...formik.getFieldProps('agentFirstName')}
            />
            {formik.touched.agentFirstName && formik.errors.agentFirstName && (
              <div className='fv-plugins-message-container'>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  {formik.errors.agentFirstName}
                </div>
              </div>
            )}
          </div>
          <div className='mb-9'>
            <label className='form-label'>
              Agent Last Name <span className='h5 text-danger'>*</span>
            </label>
            <input
              type='text'
              className='form-control form-control-solid'
              placeholder='Enter Agent Name'
              {...formik.getFieldProps('agentLastName')}
            />
            {formik.touched.agentLastName && formik.errors.agentLastName && (
              <div className='fv-plugins-message-container'>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  {formik.errors.agentLastName}
                </div>
              </div>
            )}
          </div>
          <div className='mb-9'>
            <label className='form-label'>
              Agent Email Id <span className='h5 text-danger'>*</span>
            </label>
            <input
              type='email'
              className='form-control form-control-solid'
              placeholder='Enter Agent Email'
              readOnly={true}
              {...formik.getFieldProps('agentEmail')}
            />
            {formik.touched.agentEmail && formik.errors.agentEmail && (
              <div className='fv-plugins-message-container'>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  {formik.errors.agentEmail}
                </div>
              </div>
            )}
          </div>
          <div className='mb-9'>
            <label className='form-label'>Agent Rep Id</label>
            <input
              type='text'
              className='form-control form-control-solid'
              placeholder='Enter Agent RepId'
              {...formik.getFieldProps('agentRepId')}
            />
            {formik.touched.agentRepId && formik.errors.agentRepId && (
              <div className='fv-plugins-message-container'>
                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                  {formik.errors.agentRepId}
                </div>
              </div>
            )}
          </div>
          <div className='mb-7'>
            <label className='form-label'>Assigned Products</label>
            <Select
              isMulti
              value={defaultValue}
              options={options}
              isClearable={false}
              onChange={(value: any) => handleChange(value)}
            />
          </div>
          <label className='form-label'>Agent Leader</label>
          <Dropdown
            fieldName={`agentLeaderName`}
            optionList={agentLeaderList?.map((leader: any) => ({
              id: leader.leaderName,
              value: leader.leaderName,
            }))}
            formik={formik}
            selectedVal={formik.values.agentLeaderName}
            handleSelectedItem={(e: any, fieldName: any) =>
              formik.setFieldValue(`agentLeaderName`, e.value)
            }
          />
        </div>
        <div className='modal-footer'>
          <button
            type='button'
            className='btn btn-light'
            data-bs-dismiss='modal'
            onClick={(e) => handleClose()}
          >
            Discard
          </button>
          <button type='submit' className='btn btn-primary' onClick={(e) => formik.submitForm()}>
            Update
          </button>
        </div>
      </div>
    </Modal>
  )
}
